import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormValidationService, ErrorHandlingService, ValidationError, FormValidator, AlertService } from 'core-lib';
import { PermitService, PermitDetailsModel } from '../services/permit.service';
import { environment } from '../../environments/environment.prod';

@Component({
  selector: 'cli-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  public vm: ChangePasswordViewModel;
  private validator: FormValidator;

  constructor(private router: Router,
    private formValidationSvc: FormValidationService,
    private errorHandlingSvc: ErrorHandlingService,
    private alertSvc: AlertService,
    private permitSvc: PermitService) {

    this.vm = new ChangePasswordViewModel();
    this.validator = this.formValidationSvc.getFormValidator(this.vm);

  }

  ngOnInit() {
    this.vm.isLoading = true;
    this.vm.isOpening = !this.permitSvc.model;

    this.permitSvc.getDetails().toPromise().then((data: PermitDetailsModel) => {

      this.vm.businessName = data.permitDetails.clientName;
      this.vm.contactName = data.permitDetails.firstName + ' ' +  data.permitDetails.lastName;
      this.vm.permitNo = data.permitDetails.permitNo;

      this.vm.isLoading = false;
      this.vm.isOpening = false;

    },
      (e) => {
        this.errorHandlingSvc.processHttpError(e);
        this.vm.isLoading = false;
        this.vm.isOpening = false;
      });
  }

  public error(fieldName: string): string {
    return this.formValidationSvc.getErrorMessage(this.vm, fieldName);
  }

  public validate(vm: ChangePasswordViewModel): Promise<void> {
    vm.errors = [];

    let specified1 = this.validator.validateRequired('password', 'Password');
    let specified2 = this.validator.validateRequired('confirmPassword', 'Password');

    this.validator.validateMinLength('password', 'Password', 6);
    this.validator.validateMinLength('confirmPassword', 'Password', 6);

    if (specified1 && specified2) {      
      this.validator.validateCustom('confirmPassword', 'Passwords do not match', () => {
        return vm.password !== vm.confirmPassword;
      });

    }

    if (vm.errors.length > 0) { return Promise.reject('Invalid input'); }

    return Promise.resolve();
  }

  public save(): Promise<void> {
    return this.validate(this.vm).then(() => {

      this.vm.isLoading = true;
      return this.permitSvc.changePassword(this.vm.password).toPromise().then(() => {

        this.alertSvc.success(environment.TOASTR_HEADER, 'The password was successfully changed', 2000, true);
        this.router.navigate(['/app/account']);

      },
        (e) => {
          let errorMessage = this.errorHandlingSvc.processHttpError(e);
          return Promise.reject(errorMessage);
        }).finally(() => {
          this.vm.isLoading = false;
        });

    },
      (e) => { });
  }

  public cancel() {
    this.router.navigate(['/app/account']);
  }

}

export class ChangePasswordViewModel {
  constructor() {
    this.errors = [];
  }
  public errors: ValidationError[];

  public isOpening: boolean;
  public isLoading: boolean;

  public businessName: string;
  public contactName: string;
  public permitNo: string;

  public password: string;
  public confirmPassword: string;
}
